export default "__VITE_ASSET__CnzDZbTr__"